import { Row, Stack } from '@christiankaindl/lyts'
import type { PageObjectResponse } from '@notionhq/client/build/src/api-endpoints'
import Text from '@shared/components/Text/Text'
import { NotionImage } from '@shared/components/Notion/NotionBlocks'
import {
  extractProperty,
  extractPropertyText,
} from '@shared/lib/notion/properties'
import * as styles from './author.css'

export function Author({ author }: { author: PageObjectResponse }) {
  const isOrganization = extractProperty(
    author.properties.Organization,
    'checkbox',
  )
  const tagline = extractPropertyText(author.properties.Tagline)

  return (
    <Row gap={0.5}>
      <NotionImage
        blockId={author.id}
        width={36}
        height={36}
        className={styles.avatar[isOrganization ? 'organization' : 'person']}
        alt=''
      />
      <Stack gap={0}>
        <Text size='0.9em' weight={500}>
          {extractPropertyText(author.properties.Name)}
        </Text>
        {tagline && (
          <Text size='small' color='tertiary' className={styles.tagline}>
            {tagline}
          </Text>
        )}
      </Stack>
    </Row>
  )
}
